import { Segment, Version } from "@ndn/naming-convention2";
export const defaultVersionConvention = Version;
export const defaultSegmentConvention = Segment;
